/* src/app/components/shared/molecules/user-menu/user-menu.component.scss */
.user-menu {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: var(--sizes-spacing-56);
}
.user-menu__name,
.user-menu__email {
  max-width: 100%;
  padding: 0 var(--sizes-spacing-22);
  text-align: center;
}
.user-menu__name,
.user-menu__email {
  display: -webkit-box;
  -webkit-line-clamp: 1;
  line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  max-height: auto;
  min-height: auto;
}
.user-menu__name {
  margin-top: var(--sizes-spacing-12);
  color: var(--neutral-10, #1a1b1f);
}
.user-menu__email {
  margin-top: var(--sizes-spacing-4);
  color: var(--neutral-variant-50, #767680);
}
.user-menu__divider {
  width: 100%;
  margin-top: var(--sizes-spacing-24);
}
.user-menu__logout {
  display: flex;
  align-items: center;
  gap: var(--sizes-spacing-8);
  padding: var(--sizes-spacing-16) var(--sizes-spacing-16);
  border: none;
  background: transparent;
  cursor: pointer;
  color: var(--neutral-variant-50);
}
.user-menu__logout mat-icon {
  font-size: var(--sizes-spacing-20);
  width: var(--sizes-spacing-20);
  height: var(--sizes-spacing-20);
}
/*# sourceMappingURL=user-menu.component-Y2H7OLDF.css.map */
